module.exports = __webpack_public_path__ + "img/logo-cavp.88f069fa.svg";